import { EventEmitter } from '@apparel/core/events';

export enum CartEvents {
    INITIALIZE = '@cart.init',
    ADD = '@cart.add',
    REMOVE = '@cart.remove',
    UPDATE = '@cart.update',
    CLEAR = '@cart.clear',
    DROPDOWN_SHOW = '@cart.dropdown.show',
    ITEMS_UPLOADED = '@¢art.items.uploaded',
    ADDONS_UPDATED = '@cart.addons.updated',
}

export const CartEmitter = new EventEmitter<CartEvents>();
